import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { JVInput } from "../../../shared/JVInput";
import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { Fetch } from "../../../shared/Fetch";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { JVCheckbox } from "../../../shared/JVCheckbox";

interface IProps {
    open: boolean,
    tableData: any,
    onClose: () => void;
    toast: any,
}

interface ISendEmail {
    to?: string[] | null,
    to_self?: boolean | null,
    moreEmails?: string | null,
    subject?: string | null,
}

const EmptyForm: ISendEmail = {
    to: [],
    to_self: false,
    moreEmails: "",
    subject: "",
};

const schema = yup.object({
    to: yup.array(yup.string().nullable()).nullable(),
    to_self: yup.boolean().nullable(),
    // moreEmails: yup.string().nullable(),
});

export const SendEmail = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [loadingReq, setLoadingReq] = useState(false);
    const [mailBody, setMailBody] = useState("");

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<ISendEmail>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = async (data: ISendEmail) => {
        if (mailBody.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: 'Mail Body Can not be empty', life: 3000 });
        } else {
            if (props.tableData[0].email === undefined || props.tableData[0].email === null || props.tableData[0].email.length === 0) {
                props.toast.current.show({ severity: 'error', detail: 'No Emails Found To Send', life: 3000 });
            } else {
                setLoading(true);
                const newData: any = { to_self: data.to_self, subject: data.subject, to: props.tableData[0].email, MoreEmails: (data.moreEmails || "").split(",").map(el => el.trim()), mailBody: mailBody.trim() };
                const response = await Fetch("MassMail/sendEmailForAsking", "POST", newData, null, props.toast);
                if (response) {
                    props.toast.current.show({ severity: 'success', detail: 'Email Send Successfully', life: 3000 });
                    setLoading(false);
                    onClose();
                } else {
                    setLoading(false);
                }
            }
        }
    }

    // const loadReqList = async () => {
    //     setLoadingReq(true);
    //     const response = await Fetch("Consultant_Mast/getAllocatedReqs", "GET", null, null, props.toast);
    //     if (response) {
    //         const data: IReq_List[] = await response.json();
    //         setReqList(data);
    //         setLoadingReq(false);
    //     } else {
    //         setLoadingReq(false);
    //     }
    // }

    const onClose = () => {
        reset(EmptyForm);
        setMailBody("");
        props.onClose();
    }
    //
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            // if (name === "req") {
            //     if (value.req !== null && value.req !== 0) {
            //         const text = "Job Descriptions : \n" + (reqList.filter(e => e.req_ID === value.req)[0]?.req_JobDescription || "");
            //         setMailBody(text);
            //     }
            // }
        });
        return () => subscription.unsubscribe();
    }, [watch, mailBody]);

    useEffect(() => {
        // if (props.open) loadReqList();
        if (props.open && props.tableData?.length > 0) {
            reset(EmptyForm);
            setMailBody("");
            // setValue("to", props.tableData[0]?.email?.map((el: any) => el.consultant_Email_ID).join(","));
            // setValue("subject", `Resume for ${props.tableData?.consultant_Name}`);
            // setFocus("to");
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Mass Mail" modal className="p-fluid" onHide={onClose}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVCheckbox column={6} label="To Self" name="to_self" control={control} error={errors.to?.message} showEmptyLabelAtTop={true} />
                <div className='field col-12 md:col-6'>
                    <label>To:</label>
                    <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{(props.tableData[0].email || []).map((el: any) => el).length} Consultant Email's</p>
                </div>
                <JVInput column={1} label="Add More Email: (Please add a comma after each email eg: abd@gm.com , def@gm.com)" control={control} name="moreEmails" error={errors.moreEmails?.message} />
                <JVInput column={2} label="Subject:" control={control} name="subject" error={errors.subject?.message} />
                <JVSunEditor value={mailBody} handleChange={setMailBody} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} disabled={loading} loading={loading} label="Send" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="Cancel" onClick={onClose} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}